import axios from "axios";

export const BillingInfo = (patientID, finalPayload) => {
    return axios.post(`https://arogyanxtdevapi.fundaclear.in/api/v1/Patient/${patientID}/Billing`, finalPayload);
};

export const fetchBillingById = (patientID, billingID) => {
    return axios.get(`https://arogyanxtdevapi.fundaclear.in/api/v1/Patient/${patientID}/Billing/${billingID}`);
};